'use client';

import { Roboto } from 'next/font/google';
import Link from 'next/link';
import { useState } from 'react';
import Slider from 'react-slick';

import type { CommonReview } from '@shared/api/get-common-reviews';
import { PATHS_PAGE } from '@shared/config';
import { unbounded } from '@shared/ui';

import styles from './reviews.module.css';

const roboto = Roboto({
  weight: ['400', '500', '700'],
  subsets: ['latin', 'cyrillic'],
});

const CustomDot = () => <div className={styles.dot} />;


type TProps = {
  reviews: CommonReview[];
  headerText: string;
};

export const Reviews = ({ reviews, headerText }: TProps) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    dotsClass: styles.slickDots,
    customPaging: CustomDot,
    arrows: false,
    centerMode: false,
    centerPadding: '0px',
    adaptiveHeight: false,
    waitForAnimate: false,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveSlide(newIndex);
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '16px',
          slidesToShow: 1,
          infinite: true,
        }
      }
    ]
  };

  return (
    <div className={styles.wrap} data-active-bg={activeSlide % 3}>
      <div className={styles.container}>
        <Slider {...settings}>
          {reviews.map((review, index) => (
            <div key={`${review.name}-${review.date}-${review.text.slice(0, 50)}`}>
              <div
                className={styles.reviewCard}
                data-bg-index={index % 3}
              >
                <Link href={PATHS_PAGE.REVIEWS} className={`${styles.header} ${roboto.className}`}>
                  {headerText}
                </Link>
                <div className={`${styles.text} ${unbounded.className}`}>
                  {review.text}
                </div>
                <div className={styles.author}>
                  <div className={`${styles.name} ${roboto.className}`}>
                    {review.name}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
